import React from 'react';
import { Link } from 'react-router-dom';
import LogoAmorc from '../assets/ordem-rosacruz-amorc-branco.png';

import IconeFacebook from '../assets/facebook-logo.svg';
import IconeTwitter from '../assets/twitter-logo.svg';
import IconeInsta from '../assets/instagram-logo.svg';

// import { Container } from './styles';

const Layouts = ({ children, menuTransparent }) => (
  <div>
    <nav className={`navbar navbar-expand-lg ${menuTransparent ? 'bg-transition' : ''}`}>
      <div className="container">
        <Link to="/" className="navbar-brand">
          {' '}
          <img src={LogoAmorc} alt="Ordem Rosacruz AMORC" title="Ordem Rosacruz AMORC" width={290} style={{ marginLeft: '-3rem' }} />
          {' '}
        </Link>
        <div className="collapse navbar-collapse justify-content-end" id="navbarItens">
          <ul className="navbar-nav">

            <li className="nav-item active">
              <Link to="/" className="nav-link"> Início </Link>
            </li>
            <li className="nav-item">
              <a href="https://www.amorc.org.br" target="_blank" rel="noopener noreferrer" className="nav-link">
                                Portal
              </a>
            </li>
            <li className="nav-item">
              <a href="https://atendimento.amorc.org.br" className="nav-link"> Contato </a>
            </li>

          </ul>

        </div>
      </div>
    </nav>
    <>
      {children}
    </>
    <footer className="footer">
      <div className="container">
        <div className="d-flex justify-content-between footer-itens flex-column flex-sm-row">
          <div className="logo d-flex justify-content-center mb-5 mb-sm-auto">
            <img src={LogoAmorc} width="250px" height="53px" alt="AMORC" />
          </div>
          <div className="infos d-flex flex-wrap col-12 col-sm-5 p-0">
            <div className="footer-info col-6 col-sm-4">
                            Sobre nós
              <p><a href="https://www.amorc.org.br/quemsomos/">Quem somos</a></p>
              <p><a href="https://www.amorc.org.br">Blog</a></p>
              <p><a href="http://atendimento.amorc.org.br/">Contato</a></p>
            </div>
            <div className="footer-info col-6 col-sm-4">
                            Legal
              <p><a href="https://www.amorc.org.br">Termos & Condições</a></p>
              <p><a href="https://www.amorc.org.br">Política de Privacidade</a></p>
            </div>
            <div className="footer-info col-6 col-sm-4">
                            Ajuda
              <p><a href="https://www.amorc.org.br/organismos-afiliados/">O que é o MAPS?</a></p>
              <p><a href="https://www.amorc.org.br/organismos-afiliados/">Como achar um O.A? </a></p>
              <p><a href="https://www.amorc.org.br/perguntas-frequentes/">FAQs</a></p>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-social">
          <div className="social">
            <a rel="noopener noreferrer" href="https://www.facebook.com/OrdemRosacruzAMORC" target="_blank">
              <img src={IconeFacebook} width="25" alt="Facebook AMORC" />
            </a>
            <a rel="noopener noreferrer" href="https://instagram.com/ordemrosacruz" target="_blank">
              <img src={IconeInsta} width="25" alt="Instagram AMORC" />
            </a>
            <a rel="noopener noreferrer" href="https://twitter.com/RosacruzAMORC" target="_blank">
              <img src={IconeTwitter} width="25" alt="Twitter AMORC" />
            </a>
          </div>
          <div className="cc">
            <p>© Antiga e Mística Ordem Rosacruz - AMORC | Todos Direitos Reservados 2019 </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

export default Layouts;
